import { i18n } from '../../localization'
import { bridgeApi } from '../network'

export async function generateShareLinkToAddCustomer({
  linkType,
  partnerId,
  customerAdditionSource,
}) {
  let url = `/customer/generateShareLink/v2?linkType=${linkType}&customerAdditionSource=${customerAdditionSource}`
  if (partnerId) {
    url = `/customer/generateShareLink/v2?linkType=${linkType}&partnerId=${partnerId}&customerAdditionSource=${customerAdditionSource}`
  }
  const { data } = await bridgeApi.get(url)
  return data
}

export async function sendOtpToAddCustomer({ fullName, phoneNumber }) {
  const { data } = await bridgeApi.post('/customer/addCustomerOtp/v2', {
    fullName: fullName,
    phoneNumber: phoneNumber,
  })

  return data?.data
}

export async function generateShareLinkforVerifyingOtpToAddCustomer({
  linkType,
  customerId,
}) {
  const { data } = await bridgeApi.get(
    `customer/generateShareLink/v2?linkType=${linkType}&customerId=${customerId}`
  )
  return data
}

export async function verifyOtpToAddCustomer({ customerId, otp, phoneNumber }) {
  const { data } = await bridgeApi.post('/customer/otp/verify', {
    customerId: customerId,
    otp: otp,
    phoneNumber: phoneNumber,
  })
  return data
}

export async function getCustomerDetails(customerId) {
  const { data } = await bridgeApi.get(
    `/customer/getCustomerPrefillDetails?customerId=${customerId}`
  )
  return data?.data
}

export async function submitPanWithDetails({
  panNo,
  customerId,
  modeOfIncome,
  dob,
  gender,
  pinCode,
  email,
}) {
  const { data } = await bridgeApi.post('/customer/details/basic', {
    panNo: panNo,
    customerId: customerId,
    modeOfIncome: modeOfIncome,
    dob: dob,
    gender: gender,
    pinCode: pinCode,
    email: email,
  })
  return data
}
export async function fetchFields() {
  const currentLocale = i18n.locale

  const { data } = await bridgeApi.get(
    `/customer/getCriterialIndexes?locale=${currentLocale}`
  )
  return data
}

export async function submitEmploymentDetails({
  customerId,
  employmentType,
  bankNameList,
  currentOccupation,
  annualIncome,
  partnerId,
}) {
  let apiEndPoint = '/customer/details/employment'
  if (partnerId) {
    apiEndPoint = `/customer/details/employment?partnerId=${partnerId}`
  }
  const { data } = await bridgeApi.post(apiEndPoint, {
    customerId,
    employmentType,
    bankNameList,
    currentOccupation,
    annualIncome,
  })
  return data?.data
}
